<script lang="ts" setup>
defineProps<{
  text: string
  title?: string
}>()
</script>

<template>
  <SidebarSection>
    <h2 v-if="title" v-animate="{ animation: 'vertical-reveal' }" class="title">
      {{ title }}
    </h2>
    <TextSpecial v-animate="{ animation: 'vertical-reveal' }" class="text-small" :text="text" />
  </SidebarSection>
</template>

<style lang="scss" scoped>
.title {
  margin-bottom: 30px;
  @include f-21;
}

:deep(p:last-child) {
  margin-bottom: 0;
}
</style>
